import React, { Component } from 'react';

import { EmailCapture } from '../EmailCapture';

import './EarlyAccess.css';

import {
	Grid,
	Segment,
	Header,
	Image,
	Icon,
	Container,
	Divider
} from 'semantic-ui-react';

export class EarlyAccess extends Component 
{
	render() 
	{
		return (
			<div>
				<div className='ea-header ui vertical masthead'>
					<div className='ui center aligned text container'>
						<Header as='h1'
							content='Early Access'
							style={{fontSize: '4em', paddingTop: '1.5em'}}
							inverted/>
					</div>
				</div>
				<Segment style={{ padding: '3em 0em', borderTop: '0px' }}>
				<Grid container stackable verticalAlign='middle'>
					<Grid.Row>
						<Grid.Column width={16} textAlign='left'>
							<Header as='h1'>What is Early Access?</Header>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column width={11} textAlign='left'>
							<p style={{fontSize: '1.2em'}}>
								Our Early Access Program enlists your help to try out and provide feedback for games in development that are not available to the public. This is part of our mission to create great games for players like you.
							</p>
							<p style={{ fontSize: '1.2em' }}>
								This program is perfect for enthusiasts interested in seeing the development process unfold from first working playable to initial release candidate or gamers who have had great ideas and wished someone would have asked their opinion on a feature or mechanic!
							</p>
							<p style={{ fontSize: '1.2em' }}>
								Providing feedback is not mandatory but we would love if it you did. Simply playing the game will help test our systems and uncover bugs that we may have missed!
							</p>
							<p style={{ fontSize: '1.2em' }}>
								Join today! This program is completely free and you can unsubscribe at any time.
							</p>
						</Grid.Column>
						<Grid.Column width={5} textAlign='right'>
							<center>
								<Image
									shape='circular'
									size='medium'
									src='../../grid_caster_icon.png' />
							</center>
						</Grid.Column>
					</Grid.Row>
				</Grid>
				</Segment>

				<Segment basic style={{ padding: '1em' }} vertical>
					<Container text style={{color: 'black'}}>
						<Header as='h3' style={{ fontSize: '2em' }}>
							<Icon name='game' />
							How Does it Work?
						</Header>
						<p style={{ fontSize: '1.2em' }}>
							We are currently working on games for iOS and Android devices and will send out invitations to test new version through Apple’s TestFlight system for iOS or Google’s Beta Test Group for Android. You can be sure that anything downloaded to your device will be safe as we only use officially sanctioned channels.
						</p>
						<p style={{ fontSize: '1.2em' }}>
							All we need to know is your email and whether you would like to test on an Android device, iOS device, or both.
						</p>
						<p style={{ fontSize: '1.2em' }}>
							Each new early access release will be available for download through Apple’s TestFlight app or the Google Play Store. We will also send out an email with detailed instructions for each platform along with information about the release.
						</p>

						<Divider />

						<Header as='h1'>
							<Icon name='commenting' />
							How do we Send Feedback?
						</Header>
						<p style={{ fontSize: '1.2em' }}>
							The game will have an in-game form to send any feedback but feedback can also be sent by simply replying to the email we send to you about that release.
						</p>
						<p style={{ fontSize: '1.2em' }}>
							You can tell us about what you liked, didn’t like, were confused by, and any suggestions for how we can make the experience better. Sometimes we will have specific features that we would like feedback on but you can send feedback for anything you like.
						</p>

						<center><Icon name='chevron down' /></center>
					</Container>
				</Segment>

				<Grid>
					<Grid.Row>
						<Grid.Column width={16}>
							<EmailCapture />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/EarlyAccess/EarlyAccess.js